module.exports = __webpack_public_path__ + "static/media/square3.bc227ad8.jpg";